import slice from "./demographicsSlice";

export default slice.reducer;
